<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column">
          <h2 class="title">
            {{ roleid == 6 ? "ສິນຄ້າອອກ Stock" : "ສິນຄ້າອອກ Stock" }}
          </h2>
        </div>
      </div>
      <b-tabs v-model="activeTab" v-if="roleid == 6">
        <b-tab-item label="ຕະຫຼາດ">
          <div class="columns scrollme">
            <div class="column">
              <b-field label="ລາຍການຕະຫຼາດ">
                <table class="table is-fullwidth is-narrow is-small">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>
                      <th class="has-text-left " width="15%">
                        ຊື່ຕະຫຼາດ
                      </th>
                      <th class="has-text-left " width="15%">
                        ແຂວງ
                      </th>
                      <th class="has-text-left " width="15%">
                        ເມືອງ
                      </th>
                      <th class="has-text-left " width="15%">
                        ບ້ານ
                      </th>
                      <th class="has-text-centered " width="30%">
                        ຈັດການ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data, index) in activemarkets" :key="data.ID">
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ data.MARKETNAME }}
                      </td>
                      <td>
                        {{ data.PROVINCENAME }}
                      </td>
                      <td>
                        {{ data.DISTRICT }}
                      </td>
                      <td>
                        {{ data.VILLAGE }}
                      </td>

                      <td class="has-text-centered">
                        <b-field group>
                          <b-field>
                            <b-button
                              class="btn-group-margin"
                              type="is-primary"
                              size="is-small"
                              @click="openMarketStock(data.ID, data.MARKETNAME)"
                              >ເບິ່ງສິນຄ້າໃນ Stock
                            </b-button>
                          </b-field>
                        </b-field>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>
        <b-tab-item label="ສິນຄ້າໃນ Stock">
          <b-field v-if="marketname === null">
            <button class="button is-info" @click="gotomarketlist">
              ເລືອກຕະຫຼາດ
            </button>
          </b-field>
          <b-field v-else>
            <b-field>
              <div class="container">
                <div class="columns">
                  <div class="column">
                    <h3 class="title">{{ marketname }}</h3>
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <b-field grouped v-if="selectedSellerid">
                      <b-field></b-field>
                      <b-field style="width:50%"></b-field>
                      <b-field style="width:20%">
                        <Multiselect
                          placeholder="ເລືອກ"
                          v-model.trim="selectedAllReason"
                          label="NAME"
                          track-by="ID"
                          :options="reasonList"
                        >
                        </Multiselect>
                      </b-field>
                      <b-button
                        class="btn-group-margin"
                        type="is-danger"
                        size="is-small"
                        @click="takeAllProductOut(selectedSellerid)"
                        >ນຳສິນຄ້າອອກທັງໝົດ
                      </b-button>
                    </b-field>

                    <b-field label="ລາຍການສິນຄ້າ">
                      <table class="table is-fullwidth is-narrow is-small">
                        <thead>
                          <tr>
                            <th class="has-text-centered " width="5%">#</th>
                            <th class="has-text-left " width="15%">
                              ລະຫັດສິນຄ້າ
                            </th>
                            <th class="has-text-left " width="20%">
                              ຊື່ສິນຄ້າ
                            </th>
                            <th class="has-text-left " width="20%">
                              ຮູບສິນຄ້າ
                            </th>
                            <th class="has-text-right " width="10%">
                              ຈຳນວນ <br />
                              ທັງໝົດ
                            </th>
                            <th class="has-text-right " width="10%">
                              ຈຳນວນ <br />
                              ຍັງເຫຼືອ
                            </th>
                            <th class="has-text-centered " width="50%">
                              ຈັດການ
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(data, index) in products"
                            :key="data.PRODUCTID_SUB"
                          >
                            <td class="has-text-centered">{{ index + 1 }}</td>
                            <td>
                              {{ data.PRODUCTID }} - {{ data.PRODUCTID_SUB }}
                            </td>
                            <td>
                              {{ data.PRODUCTNAME_SUB }} <br>
                              {{ data.PRODUCTNAME_ENSUB }}
                            </td>
                            <td>
                              <img
                                data-v-xcxcc
                                :src="getImgUrl(data.PHOTONAME)"
                                width="100"
                                height="100"
                              />
                            </td>
                            <td class="has-text-right ">
                              {{ data.ORIGINALQUANTITY | formatNumberLocal }}
                              {{ data.UNIT }}
                            </td>
                            <td class="has-text-right ">
                              {{ data.QUANTITY | formatNumberLocal }}
                              {{ data.UNIT }}
                            </td>

                            <td class="has-text-right">
                              <b-field grouped>
                                <b-field style="width:10%"></b-field>
                                <b-field style="width:20%">
                                  <input
                                    type="text"
                                    class="input"
                                    v-model="data.PRODUCTOUT"
                                    maxlength="4"
                                    size="4"
                                    placeholder="ຍັງເຫຼືອ"
                                  />
                                </b-field>
                                <b-field style="width:40%">
                                  <Multiselect
                                    placeholder="ເລືອກ"
                                    v-model.trim="selectedReason"
                                    label="NAME"
                                    track-by="ID"
                                    :options="reasonList"
                                  >
                                  </Multiselect>
                                </b-field>
                                <b-field style="width:20%">
                                  <b-button
                                    class="btn-group-margin"
                                    type="is-danger"
                                    size="is-small"
                                    @click="takeProductOut(data)"
                                    >ນຳສິນຄ້າອອກ
                                  </b-button>
                                </b-field>
                              </b-field>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </b-field>
                  </div>
                </div>
              </div>
            </b-field>
          </b-field>
        </b-tab-item>
      </b-tabs>
    </div>
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
import Multiselect from "vue-multiselect";
import moment from "moment";
// import axios from "axios";

export default {
  components: { Multiselect },
  props: ["MONTH"],
  data() {
    return {
      userName: null,
      roleid: null,
      activemarkets: [],
      marketid: null,
      marketname: null,
      products: [],

      activeTab: 0,

      photoname: null,
      photopath:
        process.env.NODE_ENV === "production"
          ? "https://agrilao.com/manager-main/api/uploads/products/"
          : "http://localhost/agrilao-manager/api/uploads/products/",
      // photopath: process.env.NODE_ENV === "production" ? "http://51.222.85.54/agrilao-manager/api/uploads/products/" : "http://localhost/agrilao-manager/api/uploads/products/",
      photopreview: null,

      todate: null,
      reasonList: [
        { ID: "1", NAME: "ສິນຄ້າເສຍຫາຍ" },
        { ID: "2", NAME: "ຂາຍນອກລະບົບ" },
      ],
      selectedAllReason: null,
      selectedReason: null,
      selectedSellerid: null,
    };
  },
  methods: {
    getImgUrl(photoname) {
      var photopreview = photoname
        ? this.photopath + photoname
        : this.photopath + "unknown.png";
      console.log("photoname: " + photoname)
      // console.log("photopreview: " + photopreview)
      return photopreview;
    },
    getMarkets() {
      RestAPI.getMarkets("ALL")
        .then((res) => {
          // console.log("list:"+ JSON.stringify(res.data))
          this.activemarkets = res.data.activemarkets;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    openMarketStock(marketid, marketname) {
      // console.log("marketname:" + marketname)
      this.activeTab = 1;
      this.marketname = marketname;
      this.marketid = marketid;
      this.getMarketProducts();
    },
    gotomarketlist() {
      this.activeTab = 0;
    },

    getMarketProducts() {
      RestAPI.getMarketProductSub(this.marketid)
        .then((res) => {
          console.log("res.data:" + JSON.stringify(res.data));
          this.products = res.data;
          this.selectedReason = null;
          this.selectedAllReason = null;
          this.selectedSellerid =
            this.products.length > 0 ? this.products[0].SELLERID : null;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    takeAllProductOut() {
      if (this.selectedAllReason != null) {
        this.$swal({
          title: "ຕ້ອງການເອົາສິນຄ້າອອກແທ້ບໍ່?",
          showCancelButton: true,
          showCloseButton: true,
          confirmButtonText: "ຕ້ອງການ",
          cancelButtonText: "ບໍ່ຕ້ອງການ",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
        }).then((result) => {
          if (result.value) {
            var params = {
              marketid: this.marketid,
              sellerid: this.selectedSellerid,
              reason: this.selectedAllReason.ID,
              username: this.username,
            };

            // console.log("params: "+ JSON.stringify(params))
            RestAPI.takeAllProductOut(params)
              .then(() => {
                this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
                this.getMarketProducts();
                this.selectedAllReason = null;
              })
              .catch((error) => {
                console.log(error);
                if (error == "Error: Request failed with status code 400") {
                  this.$swal("Check Input Data", "", "error");
                } else {
                  this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                }
              });
          }
        });
      } else {
        this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
        return false;
      }
    },

    takeProductOut(data) {
      console.log("data: ", JSON.stringify(data));

      if (data.PRODUCTOUT >= 0 && this.selectedReason != null) {
        if (Number(data.PRODUCTOUT) > Number(data.QUANTITY)) {
          this.$swal("ຈຳນວນອອກຫຼາຍກວ່າ ຈຳນວນທີ່ມີ", "", "error");
          return false;
        }
        this.$swal({
          title: "ຕ້ອງການເອົາສິນຄ້າອອກແທ້ບໍ່?",
          showCancelButton: true,
          showCloseButton: true,
          confirmButtonText: "ຕ້ອງການ",
          cancelButtonText: "ບໍ່ຕ້ອງການ",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
        }).then((result) => {
          if (result.value) {
            var params = {
              marketid: this.marketid,
              sellerid: data.SELLERID,
              quantity: data.QUANTITY,
              productid: data.PRODUCTID,
              productid_sub: data.PRODUCTID_SUB,
              productremain: data.PRODUCTOUT,
              reason: this.selectedReason.ID,
              username: this.username,
            };

            console.log("params: " + JSON.stringify(params));
            RestAPI.takeProductOut(params)
              .then(() => {
                this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
                this.getMarketProducts();
              })
              .catch((error) => {
                console.log(error);
                if (error == "Error: Request failed with status code 400") {
                  this.$swal("Check Input Data", "", "error");
                } else {
                  this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                }
              });
          }
        });
      } else {
        this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
        return false;
      }
    },
    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },

    print() {
      window.print();
    },
  },
  mounted() {
    // console.log("this.user.BRANCHPROVNICEID: " + JSON.stringify(this.user));
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;
    this.userProvinceID = this.user.BRANCHPROVNICEID
      ? this.user.BRANCHPROVNICEID
      : "all";
    // this.getFarmerList();
    this.getMarkets();
  },
  computed: {
    formdatestr() {
      return new moment(this.formdate).format("YYYY-MM-DD");
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.borderless td,
.borderless th {
  border: none;
}
</style>
